import Auth from './Modules/Auth'
import Product from './Modules/Product'
import User from './Modules/User'
import ApiOff from './Modules/Apioff'

const auth = Auth.build()
const product = Product.build()
const user = User.build()
const apiOff = ApiOff.build()

export { auth, product, user, apiOff }
